import { Component, OnDestroy, OnInit, ViewChild, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BookingService } from 'app/modules/bookings/services/booking.service';
import * as momentImported from 'moment';
const moment = (momentImported as any).default || momentImported;
import { ConfirmationService, Message } from 'primeng/api';
import { MiGrid2Component } from '../../../shared/components/mi-grid-2/mi-grid-2.component';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { AppSettings } from '../../app.settings';
import { VehicleTransferScreenFilterModel } from '../../save-filter-models/vehicle-transfer-screen-filter-model';
import { VehicleTransferScreenFiltersDataModel } from '../../save-filter-models/vehicle-transfer-screen-filters-data-model';
import { PickupLocationOptionsService } from '../../services/pickup-location-options.service';
import { StorageService } from '../../services/storage.service';
import { UiService } from '../../services/ui.service';
import { UserCommonService } from '../../services/user-common.service';

@Component({
  selector: 'app-shared-vehicle-transfer',
  templateUrl: './shared-vehicle-transfer.component.html',
  styleUrls: ['./shared-vehicle-transfer.component.scss']
})

export class SharedVehicleTransferComponent implements OnInit, OnDestroy {

  @ViewChild(MiGrid2Component) gridRef2: MiGrid2Component;
  gridTheme = 'mi';
  showSerialNo = false;
  url = '';
  tempUrl = '/secure/tour/list/data?type=ACTIVE&subServiceType=VEHICLE_TRANSFER';
  urlMethod: string = AppSettings.BOOKING_GRID_API_METHOD;
  bodyMapping: any = {
    type: 'string',
    subServiceType: 'array',
    pickupAddressId: 'array',
    dropAddressId: 'array',
    serviceAreaId: 'array',
    statusId: 'array',
    fromDate: 'number',
    toDate: 'number',
    sortBy: 'string',
    vehicleTypeId: 'array',
    nextAvailableTime: 'number',
    serviceTypeId: 'array'
  };
  gridColumn: any;
  assignHeader;
  message: Message[] = [];
  columns: any = [];
  params: any = '';
  exportUrl = '';
  eventIdParam;
  printUrl = '';
  recordCount = 0;
  bookingCancelsPopup = false;
  cancelHeader;
  yearRange = AppSettings.YEAR_RANGE_SELECTION;
  textToprint = '';
  hasShowDriverSideBar = false;
  bookingDetails;
  dateRange;
  minDate: Date = null;
  maxDate: Date = new Date();
  fromDate = null;
  toDate = null;
  fromDateMilliSeconds: any = '';
  toDateMilliSeconds: any = '';
  dispatchLocations: any = [];
  dispatchPostData: any = {};
  selectedBookingId;
  locationCategoryId;
  selectedLocationId;
  msgs: Message[] = [];
  driverList = [];
  statusListToChange = AppSettings.BOOKING_STATUS_CODES_OPTIONS;
  statusListFilterOptions = AppSettings.BOOKING_STATUS_CODES_FILTER_OPTIONS;
  searchPlaceHolder;
  dateRangePlaceHolder;
  pickupDropPlaceHolder;
  fromDatePlaceHolder;
  toDatePlaceHolder;
  invalidAction;
  companyOptions = [];
  assignDriverPopUpShow = false;
  pickupLocationsOptions: any[] = [];
  locationList: any[] = [];
  dropLocationsOptions: any[] = [];
  serviceCitiesOptions: any[];
  selectedPickupLocation: any = [];
  selectedDropLocation: any = [];
  selectedBookingStatus = [];
  selectedDispatchAddress: any = [];
  _broadSub;
  paginationCount = AppSettings.BOOKING_DEFAULT_PAGINATION;
  sortTypeOptions = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS;
  selectedSortType: String = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS[0].value;
  changeBookingStatusAllow: Boolean = true;
  collapsed = false;
  originalFilterData: any;
  changedFilterData: any;
  filterApplied = false;
  gridScrollHeight = '';
  uniqId = AppSettings.UNIQID.SHARED_VEHICL_TRANSF_5FE8;
  selectedVehicleTypeId: any = [];
  vehicleTypeOptions: any[] = [];
  currentRoute: string;
  nextAvailableTime: any;
  showETAFilter: Boolean = false;
  etaTimeOptions = AppSettings.ETA_TIME_OPTIONS;
  showCancellationReasonPopup: boolean = false;
  selectedBookingForCancellation = '';
  dateFormat: any;
  loadGrid = signal(false);

  constructor(
    private router: Router,
    private commonBindingDataService: CommonBindingDataService,
    private userCommonService: UserCommonService,
    private confirmationService: ConfirmationService,
    private uiService: UiService,
    private storageService: StorageService,
    private pickupLocationOptionsService: PickupLocationOptionsService,
    private bookingService: BookingService
  ) {}

  ngOnInit() {
    this.changeBookingStatusAllow = this.commonBindingDataService.hasLogicalAccessPresent('UPDATE_JOURNEY_STATUS', 'CURRENT_BOOKINGS');
    this.currentRoute = this.router.url.split('/')[2]
    this.commonBindingDataService.bookingTabCountChange.next(true);
    this.cancelHeader = this.commonBindingDataService.getLabel('label_select_dispatch_location');
    if (this.commonBindingDataService.hasLogicalAccessPresent('CURRENT_BOOKING_EXPORT_CURRENT_BOOKINGS_EXCEL', 'CURRENT_BOOKINGS')) {
      this.exportUrl = '/secure/tour/list/data/export/xls';
    }

    if (this.commonBindingDataService.hasLogicalAccessPresent('BOOKINGS_EXPORT_IN_PDF', 'CURRENT_BOOKINGS')) {
      this.printUrl = '/secure/booking/list/data/export/pdf';
    }
    this._broadSub = this.commonBindingDataService.bookingGridRefresh.subscribe((result) => {
      if (result === AppSettings.SUB_BOOKINMG_SERVICE_TYPES_LIST.VEHICLETRANSFER) {
        this.gridRef2.refreshList();
      }
    });

    this.dateFormat = this.commonBindingDataService.getDateFormat();

    const storedEventId = this.storageService.getItemFromSessionStorage('storedEventId');
    if (storedEventId) {
      this.eventIdParam = storedEventId;
    }

    if (!this.eventIdParam) {
      let tempEventId = this.commonBindingDataService.changedEventId;
      if (tempEventId) {
        this.eventIdParam = tempEventId;
      }
    }

    if (this.eventIdParam) {
      this.loadInitialData();
    }

    this.commonBindingDataService.eventId.subscribe(result => {
      this.eventIdParam = result;
      this.loadInitialData();
    });

    this.searchPlaceHolder = this.commonBindingDataService.getLabel('label_search_by_driver_journey_id');
    this.dateRangePlaceHolder = this.commonBindingDataService.getLabel('label_from_to_todate');
    this.pickupDropPlaceHolder = this.commonBindingDataService.getLabel('All');
    this.fromDatePlaceHolder = this.commonBindingDataService.getLabel('label_from_date');
    this.toDatePlaceHolder = this.commonBindingDataService.getLabel('label_to_date');
    this.invalidAction = this.commonBindingDataService.getLabel('error_invalid_action_VT');
    this.companyOptions = [
      {
        label: this.commonBindingDataService.getLabel('label_all'),
        value: ''
      }];
    this.getColumns();
  }

  loadInitialData() {
    this.getVehicleTypes();
    // this.getPickupAddress();
    this.getServiceCityList();
  }

  getColumns() {
    this.columns.push({
      field: 'bookingCode', width: 80, header: this.commonBindingDataService.getLabel('label_booking_ID'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getBookingCode(i)),
    });
    this.columns.push({
      field: 'pickupDateTimeStr', width: 90, header: this.commonBindingDataService.getLabel('label_pickup_at'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.firstCell(i)),
    });
    this.columns.push({
      field: 'pFirstName', width: 120, header: this.commonBindingDataService.getLabel('grid_passenger'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getPassengerName(i)),
    });
    this.columns.push({
      field: 'pickupLocationName', width: 120, header: this.commonBindingDataService.getLabel('grid_pickup_drop_off'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getPickDropLocation(i)),
    });
    this.columns.push({
      field: 'Info', width: 120, header: this.commonBindingDataService.getLabel('label_driver_info'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getDriver(i)),
    });
    this.columns.push({
      field: 'bookingStatus', header: this.commonBindingDataService.getLabel('label_status_and_parking'),
      sort: false, resize: true, isDropDown: true, options: this.statusListToChange,
      noteText: 'bookingStatus', estimatedDropOffTimeStr: 'estimatedDropOffTimeStr', locationId: 'locationId',
      dropdownCount: 1, width: 140, disabled: !this.changeBookingStatusAllow,
      bookingStatus: 'bookingStatus', borderClass: 'border-class'
    });

    if (this.commonBindingDataService.hasLogicalAccessPresent('ASSIGN_DRIVER_TO_JOURNEY', 'CURRENT_BOOKINGS')) {
      this.columns.push({
        field: '', header: this.commonBindingDataService.getLabel('label_action'),
        sort: false, resize: true, cellRendererHtml: (i) => (this.actionCells(i)), width: 100
      });
    }
  }

  initializeUrl() {
    let filterData = this.gateAllFilters();
    if (filterData) {
      const localData = filterData.filterData;
      this.collapsed = (localData.opencloseFilter) ? ((localData.opencloseFilter.toString() === 'true') ? true : false) : false;
      this.gridScrollHeight = this.collapsed ? 'calc(100vh - 280px)' : 'calc(100vh - 400px)';
      this.selectedPickupLocation = localData.selectedPickupLocation ? localData.selectedPickupLocation?.split(',') : [];
      this.selectedDropLocation = localData.selectedDropLocation ? localData.selectedDropLocation?.split(',') : [];
      if (filterData.filterData.selectedDispatchAddress) {
        this.selectedDispatchAddress = filterData.filterData.selectedDispatchAddress.split(',').map(item => item.trim())?.filter(id =>
          this.serviceCitiesOptions?.some(city => city.value === id)
        );
      } else {
        this.selectedDispatchAddress = [];
      }
      this.getPickupAddress();
      this.selectedSortType = localData.selectedSortType ? localData.selectedSortType : this.selectedSortType;
      this.selectedBookingStatus = localData.selectedBookingStatus ? JSON.parse('[' + localData.selectedBookingStatus + ']') : [];
      this.nextAvailableTime = localData.nextAvailableTime ? localData.nextAvailableTime : this.nextAvailableTime;
      this.selectedVehicleTypeId = localData.selectedVehicleTypeId ? localData.selectedVehicleTypeId?.split(',') : [];
      if (this.selectedSortType === 'eta') {
        this.showETAFilter = true
      }
      const timeZone: string = this.storageService.getItemFromSessionStorage('storedTimezone');
      if (localData.fromDateMilliSeconds) {
        const fromDateInTimeZone = moment.tz(+localData.fromDateMilliSeconds, timeZone).startOf('day');
        this.fromDateMilliSeconds = fromDateInTimeZone.valueOf();
        this.fromDate = fromDateInTimeZone.toDate();
      } else {
        this.fromDateMilliSeconds = '';
        this.fromDate = null;
      }

      if (localData.toDateMilliSeconds) {
        const toDateInTimeZone = moment.tz(+localData.toDateMilliSeconds, timeZone).endOf('day').subtract(1, 'second');
        this.toDateMilliSeconds = toDateInTimeZone.valueOf();
        this.toDate = toDateInTimeZone.toDate();
      } else {
        this.toDateMilliSeconds = '';
        this.toDate = null;
      }

      this.url = `${this.tempUrl}&pickupAddressId=${this.selectedPickupLocation}&dropAddressId=${this.selectedDropLocation}` +
        `&serviceAreaId=${this.selectedDispatchAddress}` +
        `&statusId=${this.selectedBookingStatus}` +
        `&fromDate=${this.fromDateMilliSeconds}&toDate=${this.toDateMilliSeconds}&sortBy=${this.selectedSortType}&vehicleTypeId=${this.selectedVehicleTypeId}&nextAvailableTime=${this.nextAvailableTime ? this.nextAvailableTime : 0}`;
    } else {
      this.url = this.tempUrl + `&sortBy=${this.selectedSortType}`;
    }
    this.loadGrid.set(true);
    this.gateAndSetAllFilters();
  }

  getVehicleTypes() {
    this.vehicleTypeOptions = [];
    // this.vehicleTypeOptions.push({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
    const vehicleTypeData: any[] = this.storageService.getItemFromSessionStorage(AppSettings.VEHICLE_TYPE_DATA);
    vehicleTypeData.forEach(element => {
      this.vehicleTypeOptions.push({ label: element.vehicleType, value: element.id });
    });
  }

  // createGrid() {
  //   this.changeBookingStatusAllow = this.commonBindingDataService.hasLogicalAccessPresent('UPDATE_JOURNEY_STATUS', 'CURRENT_BOOKINGS');
  //   this.columns.push({
  //     field: 'bookingCode', width: 120, header: this.commonBindingDataService.getLabel('label_booking_ID'),
  //     sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getBookingCode(i)),
  //   });
  //   this.columns.push({
  //     field: 'pickupDateTimeStr', width: 70, header: this.commonBindingDataService.getLabel('label_pickup_at'),
  //     sort: false, resize: true, cellRendererHtml: (i) => (this.firstCell(i)),
  //   });
  //   this.columns.push({
  //     field: 'pFirstName', width: 150, header: this.commonBindingDataService.getLabel('grid_passenger'),
  //     sort: false, resize: true, cellRendererHtml: (i) => (this.getPassengerName(i)),
  //   });
  //   this.columns.push({
  //     field: 'pickupLocationName', width: 180, header: this.commonBindingDataService.getLabel('grid_pickup_drop_off'),
  //     sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getPickDropLocation(i)),
  //   });
  //   this.columns.push({
  //     field: 'Info', width: '13%', header: this.commonBindingDataService.getLabel('label_driver_info'),
  //     sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getDriver(i)),
  //   });
  //   this.columns.push({
  //     field: 'bookingStatus', header: this.commonBindingDataService.getLabel('label_status_and_parking'),
  //     sort: false, resize: true, isDropDown: true, options: this.statusListToChange,
  //     noteText: 'bookingStatus', estimatedDropOffTimeStr: 'estimatedDropOffTimeStr', locationId: 'locationId',
  //     dropdownCount: 1, width: 200, disabled: !this.changeBookingStatusAllow,
  //     bookingStatus: 'bookingStatus', borderClass: 'border-class'
  //   });

  //   if (this.commonBindingDataService.hasLogicalAccessPresent('ASSIGN_DRIVER_TO_JOURNEY', 'CURRENT_BOOKINGS')) {
  //     this.columns.push({
  //       field: '', header: this.commonBindingDataService.getLabel('label_action'),
  //       sort: false, resize: true, cellRendererHtml: (i) => (this.actionCells(i)), width: '150px'
  //     });
  //   }
  // }

  getRequestedVehicleType(params) {
    const eDiv = document.createElement('div');
    let requestedVT = `<div title="${params.vehicleType}" style="text-align:center;">${params.vehicleType}</div>`
    eDiv.innerHTML += requestedVT;
    return eDiv;
  }

  firstCell(params) {
    const eDiv = document.createElement('div');
    const lblStatus = `<div class="booking-grid-table">
      <div class = "pickup-time">` + params.pickupTimeStr + `</div>
      <div class = "pickup-date">` + params.pickupDateStr + `</div>
       ${params.stopOneAddress && params.stopOneLatitude && params.stopOneLongitude ? `<div class='multi-stop mt-2' title="${params.stopOneAddress}">Additional Stop</div>` : ''}
    </div>`;
    eDiv.innerHTML += lblStatus;
    return eDiv;
  }

  getPassengerName(params) {
    const firstName = params.firstName ? params.firstName : '--';
    const lastName = params.lastName ? params.lastName : '--';
    const priority = params.passengerType ? params.passengerType : '';
    const passengerCount = params.totalNoOfPassengers;
    const eDiv = document.createElement('div');
    let preparedData = '';
    let preparedData1 = '';
    if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.GENERAL ||
      params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.SPECIAL_EVENT ||
      params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY) {
      preparedData1 = `<div class="booking-grid-table" title="">
        <div class="passenger-name passengerName" title="${firstName} ${lastName}">` + firstName + `&nbsp` + lastName + `</div>
        <div class="passengerType my-2" title="${priority}">${priority}</div>
      </div>`;
      preparedData = params.luggageTour ? `<div class = "pickup-date drop-adr pass-info passenger passengerInfo pb-2">${params.luggageTour ? (params.luggageWithTotalNoOfBagsString ? params.luggageWithTotalNoOfBagsString : '') : ''}</div>` :
        `<div title="${passengerCount} Pass ${params.totalNoOfBabyseats > 0 ? `| ${params.totalNoOfBabyseats}C` : ''} ${params.totalNoOfWheelchairs > 0 ? ` | ${params.totalNoOfWheelchairs}W` : ''} ${params.totalNoOfLuggageBagsString ? `| ${params.totalNoOfLuggageBagsString}` : ''}" class="pickup-date drop-adr pass-info passenger passengerInfo pb-2">${passengerCount} Pass <span class="child-seat">
      ${params.totalNoOfBabyseats > 0 ? `| ${params.totalNoOfBabyseats}C` : ''}
      ${params.totalNoOfWheelchairs > 0 ? ` | ${params.totalNoOfWheelchairs}W` : ''}
      ${params.totalNoOfLuggageBagsString ? `| ${params.totalNoOfLuggageBagsString}` : ''}
    </span></div>`;
    } else {
      let title = this.commonBindingDataService.getLabel('SHUTTLE');
      if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.VEHICLE_TRANSFER) {
        title = this.commonBindingDataService.getLabel('VEHICLE TRANSFER');
      }
      preparedData = `<div class="booking-grid-table" title="${title}">
      <div class = "passenger-name passengerName">` + title + `</div>
      </div>`;
    }
    eDiv.innerHTML += preparedData1;
    eDiv.innerHTML += preparedData
    return eDiv;
  }

  getPickDropLocation(params) {
    const eDiv = document.createElement('div');
    // const addressInstructions = (params.tripNote) ? params.tripNote : '';
    const addressInstructions = this.prepareNote(params);
    const PreparedData = `
    <div style="margin-top: -13px;margin-bottom: -4px;">
    <div class="col-12 booking-grid-table booking-details pad-top" title="">
    <div clas="col-12">
      <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
        <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
        <div class="divider"></div>
        <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
      </div>
      <div class="col-10 md:col-10 lg:col-10 passenger-name">
        <div class="passenger-name" title="${params.pickupLocationName}">` + params.pickupLocationName + `</div>
        <div class="pickup-date drop-adr opa-9" title="${params.dropLocationName}">` + params.dropLocationName + `</div>
      </div>
    </div>` + ((params.tripNote || params.passengerNote || params.passengerStayAddressNote) ? `
    <div clas="col-12" style="margin-top: -5px;">
      <span class="address-instrn" title="${addressInstructions}"><img src="/assets/images/temp/info-icon.svg"></span>
    </div>` : '') +
      `</div></div>`;

    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  prepareNote(params) {
    let totalNote = '';
    if (params.tripNote) {
      totalNote += `Booking note: ${params.tripNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    if (params.passengerNote) {
      totalNote += `Passenger note: ${params.passengerNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    if (params.passengerStayAddressNote) {
      totalNote += `Address note: ${params.passengerStayAddressNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    return totalNote;
  }

  getInfo(params) {
    const vehicleCode = (params.vehicleCode) ? params.vehicleCode : '--';
    const vehicleRegistration = (params.vehicleRegistration) ? params.vehicleRegistration : '--';
    const vehicleColor = (params.vehicleColor) ? params.vehicleColor : '--';
    const vehicleCapacity = (params.vehicleCapacity) ? params.vehicleCapacity : '0';
    const vehicleMakeModel = (params.vehicleMakeModel) ? params.vehicleMakeModel : '';
    const vehicleModelName = (params.vehicleModelName) ? params.vehicleModelName : '';
    const vehicleNumber = (params.vehicleNumber) ? params.vehicleNumber : '';
    const vehicleDescriptionLine1 = `${vehicleMakeModel} ${vehicleModelName} (${vehicleCapacity})`;
    const vehicleDescriptionLine2 = `${vehicleNumber}`;
    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table" title="">
      <div class = "passenger-name">${vehicleRegistration}</div>
      <div class = "pickup-date">
        <div title = "${vehicleDescriptionLine1}">${vehicleDescriptionLine1}</div>
        <div title = "${vehicleDescriptionLine2}">${vehicleDescriptionLine2}</div>
      </div>
      </div>`;

    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getvehicle(params) {
    const passengerCount = params.totalNoOfPassengers;
    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table" title="${params.vehicleType}">
    <div class = "pickup-time"><span>${params.vehicleType}</span></div>
    </div>`;

    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  actionCells(params) {
    let assignType = 'assignDrivers';
    let assignIcon = '/assets/images/temp/icon-reassign-grid.svg';
    let isEnabled = true;
    let buttonLabel = this.commonBindingDataService.getLabel('label_view_details');
    let showIcon = false;

    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-btn-div buttons action-buttons-container');
    
    const disabledClass = isEnabled ? '' : ' disabled';
    const hasNextButton = params.showMergeButton === true || params.showUnmergeButton === true;
    const marginStyle = hasNextButton ? 'margin-right: 12px;' : '';
    const assignReassignBtn = `<div data-action-type=${assignType} class="grid-btn-div re-assign-btn${disabledClass}" style="${marginStyle}" title="${buttonLabel}">
       ${buttonLabel}
    </div>`;
    
    let mergeBtn = '';
    if (params.showMergeButton === true) {
      const hasNextButton = params.showUnmergeButton === true;
      const marginStyle = hasNextButton ? 'margin-right: 12px;' : '';
      mergeBtn = `<div data-action-type="mergeBooking" class="grid-btn-div grid-action-icon-btn" style="${marginStyle}" title="Merge">
         <img src="/assets/images/temp/merge-grid.svg" alt="Merge" />
      </div>`;
    }
    
    let unmergeBtn = '';
    if (params.showUnmergeButton === true) {
      unmergeBtn = `<div data-action-type="unmergeBooking" class="grid-btn-div grid-action-icon-btn" title="Unmerge">
         <img src="/assets/images/temp/unmerge-grid.svg" alt="Unmerge" />
      </div>`;
    }
    
    eDiv.innerHTML = assignReassignBtn + mergeBtn + unmergeBtn;
    
    const actionButtons = eDiv.querySelectorAll('[data-action-type]');
    actionButtons.forEach(button => {
      const element = button as HTMLElement;
      element.setAttribute('data-row-id', params.id);
      const isDisabled = element.classList.contains('disabled');
      if (isDisabled) {
        element.style.pointerEvents = 'auto';
        element.style.cursor = 'not-allowed';
        element.setAttribute('aria-disabled', 'true');
        return;
      }

      element.style.pointerEvents = 'auto';
      element.style.cursor = 'pointer';
      element.removeAttribute('aria-disabled');

      const actionType = element.getAttribute('data-action-type');
      const rowData = params;
      
      const handleActionClick = (event: Event) => {
        const mouseEvent = event as MouseEvent;
        mouseEvent.stopImmediatePropagation();
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();
        if (actionType) {
          this.handleActionDirectly(actionType, rowData);
        }
        return false;
      };
      
      element.addEventListener('click', handleActionClick, { capture: true, passive: false });
    });
    
    return eDiv;
  }

  reloadGrid() {
    setTimeout(() => {
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, 1000);
    this.gridRef2.updateUrl(this.tempUrl + this.params);
  }

  refreshGrid() {
    this.gridRef2.refreshList();
  }

  goToManualBookingPage() {
    this.router.navigate(['bookings/manual-booking']);
  }

  onclickFilterApply() {
    this.applyFilter();
  }

  applyFilter() {
    this.params = '';
    if (this.fromDate !== undefined) {
      const timeZone: string = this.storageService.getItemFromSessionStorage('storedTimezone');
      // Set the fromDate to midnight in the selected timezone
      const fromDateWithTimeZone = moment.tz(this.fromDate, timeZone).startOf('day');

      this.fromDateMilliSeconds = fromDateWithTimeZone.valueOf();
      this.params += ('&fromDate=' + this.fromDateMilliSeconds);
    }
    if (this.toDate !== undefined) {
      const timeZone: string = this.storageService.getItemFromSessionStorage('storedTimezone');
      // Set the toDate to midnight in the selected timezone
      const toDateWithTimeZone = moment.tz(this.toDate, timeZone).endOf('day').subtract(1, 'second');
      this.toDateMilliSeconds = toDateWithTimeZone.valueOf();
      this.params += ('&toDate=' + this.toDateMilliSeconds);
    }
    if (this.selectedPickupLocation !== undefined && this.selectedPickupLocation !== null) {
      this.params += (`&pickupAddressId=${this.selectedPickupLocation}`);
    }
    if (this.selectedDropLocation !== undefined && this.selectedDropLocation !== null) {
      this.params += (`&dropAddressId=${this.selectedDropLocation}`);
    }
    if (this.selectedDispatchAddress !== undefined && this.selectedDispatchAddress !== null) {
      this.params += (`&serviceAreaId=${this.selectedDispatchAddress}`);
    }
    if (this.selectedBookingStatus !== undefined && this.selectedBookingStatus !== null) {
      this.params += (`&statusId=${this.selectedBookingStatus}`);
    }
    if (this.selectedSortType !== undefined && this.selectedSortType !== null) {
      this.params += (`&sortBy=${this.selectedSortType}`);
    }
    if (this.selectedVehicleTypeId !== undefined && this.selectedVehicleTypeId !== null) {
      this.params += (`&vehicleTypeId=${this.selectedVehicleTypeId}`);
    }
    if (this.nextAvailableTime !== undefined && this.nextAvailableTime !== null) {
      this.params += (`&nextAvailableTime=${this.nextAvailableTime}`);
    }
    this.reloadGrid();
    this.updateSaveFilter();
  }

  resetFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.fromDateMilliSeconds = '',
      this.toDateMilliSeconds = '',
      this.dateRange = null;
    this.selectedPickupLocation = [];
    this.selectedDropLocation = [];
    this.selectedDispatchAddress = [];
    this.selectedBookingStatus = [];
    this.selectedVehicleTypeId = [];
    this.selectedSortType = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS[0].value;
    this.params = ''; // '?fromDate=&toDate=';
    this.minDate = null;
    this.maxDate = new Date();
    this.nextAvailableTime = null;
    this.showETAFilter = false;
    this.reloadGrid();
    this.updateSaveFilter();
    this.getPickupAddress();
  }

  updateSaveFilter() {
    const saveFilterModel = new VehicleTransferScreenFilterModel({
      screenCode: AppSettings.FILTER_SCREEN_CODE.VEHICLE_TRANSFER_SCREEN,
      filterData: new VehicleTransferScreenFiltersDataModel({
        selectedPickupLocation: this.selectedPickupLocation.toString(),
        selectedDropLocation: this.selectedDropLocation.toString(),
        fromDateMilliSeconds: this.fromDateMilliSeconds,
        toDateMilliSeconds: this.toDateMilliSeconds,
        selectedDispatchAddress: this.selectedDispatchAddress.toString(),
        selectedBookingStatus: this.selectedBookingStatus.toString(),
        selectedSortType: this.selectedSortType,
        nextAvailableTime: this.nextAvailableTime,
        opencloseFilter: this.collapsed,
        selectedVehicleTypeId: this.selectedVehicleTypeId.toString(),
      }),
    });

    this.userCommonService.updateSavedFilter(saveFilterModel).subscribe(result => {
      this.userCommonService.updateFilterDataToLocal(result);
      setTimeout(() => {
        this.gateAndSetAllFilters();
      }, 100);
      this.filterApplied = false;
    }, (error) => {
    });
  }

  onSelectDispatchLocation(locationInfo) {
    this.dispatchPostData = {
      'tourId': this.selectedBookingId,
      'locationId': locationInfo.id,
      'eta': locationInfo.eta,
      'distance': locationInfo.distance,
    }
    this.commonBindingDataService.setDispatchLocation(this.dispatchPostData).subscribe(result => {
      if (result) {
        this.showMessage('Success', result.general[0].message);
        this.refreshGrid();
        this.bookingCancelsPopup = false;
      }
    }, (error) => {
      this.showMessage('Error', error.general[0].message);
    })
  }

  changeBookingStatus(event) {
    switch (event.value) {
      case AppSettings.BOOKING_STATUS_CODES.NEW_REQUEST:
        this.statusChangeToNewRequest(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED:
        this.statusChangeToAdminConfirmed(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED:
        this.statusChangeToDriverConfirmed(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_RECONFIRM:
        this.statusChangeToAccept(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_ON_THE_WAY:
        this.statusDriverOnTheWay(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_ARRIVED:
        this.statusDriverArrived(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.ON_TRIP:
        this.statusOnTrip(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.EXPIRED:
        this.statusExpired(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.CANCELED:
        this.statusCanceledV1(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.COMPLETED:
        this.statusCompleted(event);
        break;
      default:
        break;
    }
  }

  statusChangeToNewRequest(event) {
    this.uiService.showMessage(this.invalidAction, AppSettings.MESSAGE_TYPE.ERROR);
    this.refreshGrid();
    // const data = { tourStatus: AppSettings.BOOKING_STATUS_CODES.NEW_REQUEST, tenantId: AppSettings.TENANT}
    // this.commonBindingDataService.changeBackToNewRequest(event.data.id, data).subscribe(results => {
    //   this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
    //   this.refreshGrid();
    // }, (error) => {
    //   this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    //   this.refreshGrid();
    // });
  }

  statusChangeToAdminConfirmed(event) {
    this.uiService.showMessage(this.invalidAction, AppSettings.MESSAGE_TYPE.ERROR);
    this.refreshGrid();
    // const data = { 'tourStatusCode': AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED }
    // this.commonBindingDataService.adminConfirmed(event.data.id, data).subscribe(results => {
    //   this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
    //   this.reloadGrid();
    // }, (error) => {
    //   this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    //   this.refreshGrid();
    // });
  }

  statusChangeToDriverConfirmed(event) {
    const data = { 'tourStatusCode': AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED }
    this.commonBindingDataService.driverFirstConfirmed(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.reloadGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusChangeToAccept(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.acknowledgeTrip(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.reloadGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusDriverOnTheWay(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.driverOntheWay(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusDriverArrived(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.driverArrived(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.reloadGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusOnTrip(event) {
    this.message = [];
    const tripStartData = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    };
    this.commonBindingDataService.startTrip(tripStartData, event.data.id).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.reloadGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusCompleted(event) {
    const chargeData = [];
    const data = {
      tourId: event.data.id,
      manualDistanceByAdmin: '',
      time: '',
      dropLocationName: '',
      endTripLatitude: event.sourceLatitude,
      endTripLongitude: event.sourceLongitude,
      inputTourAdditionalReasonList: chargeData,
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0
    };
    this.commonBindingDataService.dropTrip(data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusExpired(event) {
    this.commonBindingDataService.bookingTabCountChange.next(true);
    this.reloadGrid();
  }

  cancelApi(id, data) {
    this.commonBindingDataService.cancelBooking(id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  // statusCanceled(event) {
  //   this.commonBindingDataService.bookingTabCountChange.next(true);
  //   if (event.data.requestLabelType === AppSettings.LUGGAGE_REQUEST || AppSettings.MULTIPLE_VEHICLE_REQUEST || AppSettings.MULTIPLE_VEHICLE_WITH_LUGGAGE_REQUEST) {
  //     this.confirmationService.confirm({
  //       message: event.data.messageToCancelAssociateBookings,
  //       accept: () => {
  //         const data = {
  //           cancellationReason: '',
  //           tourIds: [event.data.id]
  //         };
  //         this.cancelApi(event.data.id, data);
  //       }
  //     });
  //   } else if (event.data && event.data.mergedRide === true) {
  //     this.confirmationService.confirm({
  //       message: 'This is a merge booking, confirming the cancellation you can now merge additional booking',
  //       accept: () => {
  //         const data = {
  //           cancellationReason: '',
  //           tourIds: [event.data.id]
  //         };
  //         this.cancelApi(event.data.id, data);
  //       }
  //     });
  //    }
  //   this.reloadGrid();
  // }

  statusCanceledV1(event: any) {
    this.selectedBookingForCancellation = event.data;
    this.showCancellationReasonPopup = true;
  }

  getEta(event: any) {
    this.bookingCancelsPopup = true;
  }
  totalCount(event: any) {
    this.recordCount = event;
  }

  getActionTypeFromEvent(event: any): string | null {
    const target = event.target;
    if (!target) return null;
    
    let element: HTMLElement | null = target;
    while (element && element !== document.body) {
      const actionType = element.getAttribute('data-action-type');
      if (actionType) {
        return actionType;
      }
      element = element.parentElement;
    }
    
    if (event.composedPath) {
      const path = event.composedPath();
      for (const pathElement of path) {
        if (pathElement && pathElement.getAttribute) {
          const actionType = pathElement.getAttribute('data-action-type');
          if (actionType) {
            return actionType;
          }
        }
      }
    }
    
    return null;
  }

  handleActionDirectly(actionType: string, data: any) {
    switch (actionType) {
      case 'assignDrivers':
        return this.navigateToBookingDetails(data);
      case 'mergeBooking':
        this.commonBindingDataService.openMergePopup(data);
        return true;
      case 'unmergeBooking':
        this.openUnmergePopup(data);
        return true;
      default:
        return undefined;
    }
  }

  private navigateToBookingDetails(data: any) {
    if (this.commonBindingDataService.hasLogicalAccessPresent('VIEW_JOURNEY_DETAILS', 'CURRENT_BOOKINGS')) {
      return this.router.navigate([`bookings/booking-details`], { queryParams: { id: data.id, navigateFrom: 'vehicleTransfer', fromScreen: this.currentRoute } });
    }
    return false;
  }

  onRowClicked(e: any) {
    const actionType = this.getActionTypeFromEvent(e.originalEvent);
    if (actionType) {
      e.originalEvent.stopPropagation();
      e.originalEvent.preventDefault();
      const handled = this.handleActionDirectly(actionType, e.data);
      if (handled !== undefined) {
        return handled;
      }
    }
    return this.navigateToBookingDetails(e.data);
  }

  checkIfReassignable(data, background?) {
    if (AppSettings.DRIVER_ASSIGN_CONDITIONS.indexOf(data.bookingStatus) > -1) {
      if (background) {
        return true;
      } else {
        return this.openSideBar(data, 'reasign');
      }
    } else {
      return false;
    }
  }

  openSideBar(data, secondArg?: any) {
    this.bookingDetails = data;
    this.hasShowDriverSideBar = true;
  }

  isPopCancel(event) {
    this.bookingCancelsPopup = false;
  }

  isPopSave(event) {
    this.bookingCancelsPopup = false;
  }

  showMessage(severity, message) {
    this.msgs = [];
    this.msgs.push({ severity: severity.toLowerCase(), summary: severity, detail: message });
  }

  selectedClass(params) {
    let returnClass = '';
    if (this.selectedLocationId === params.id) {
      returnClass = 'background-selected';
    }
    return returnClass;
  }

  getPickupAddress() {
    const serviceAreaId = Array.isArray(this.selectedDispatchAddress)
      ? this.selectedDispatchAddress.join(',')
      : String(this.selectedDispatchAddress ?? '');
    const eventId = this.eventIdParam != null ? String(this.eventIdParam) : '';
    this.pickupLocationOptionsService.getPickupAddress(serviceAreaId, eventId).subscribe((results) => {
      this.pickupLocationsOptions = results.map(ele => ({ label: ele.code, value: ele.id }));
    });
  }

  getServiceCityList() {
    this.serviceCitiesOptions = [];
    this.commonBindingDataService.getCitiesV1(this.eventIdParam).subscribe(results => {
      this.serviceCitiesOptions = results.map(element => ({ label: element.cityAliasName, value: element.id }));
      this.initializeUrl();
      // this.serviceCitiesOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
    }, (error) => {
      error = JSON.parse(error);
    });
  }

  showThirdPartyPopUp() {
    this.assignDriverPopUpShow = true;
  }

  onThirdPartyCancel() {
    this.assignDriverPopUpShow = false;
  }

  onSelectDates(e, from) {
    if (from === 'fromDate') {
      this.minDate = this.fromDate;
      this.changeFilter('fromDateMilliSeconds', this.fromDate.getTime().toString());
    }
    if (from === 'toDate') {
      this.maxDate = this.toDate;
      let finalToTime = this.commonBindingDataService.addLapseTimeInEndDate(this.toDate.getTime());
      this.changeFilter('toDateMilliSeconds', finalToTime.toString());
    }
  }

  onAfterToggle(event?) {
    this.collapsed = event.collapsed;
    this.updateOpenCloseFilter();
    this.gridScrollHeight = this.collapsed ? 'calc(100vh - 280px)' : 'calc(100vh - 400px)';
  }

  updateOpenCloseFilter() {
    const saveFilterModel = {
      screenCode: AppSettings.FILTER_SCREEN_CODE.VEHICLE_TRANSFER_SCREEN,
      filterData: {
        opencloseFilter: this.collapsed,
      },
    };

    this.userCommonService.updateFilterOpenClose(saveFilterModel, 'opencloseFilter').subscribe(result => {
      this.userCommonService.updateFilterDataToLocal(result, 'opencloseFilter', result.filterData.opencloseFilter);
    }, (error) => {
    });
  }

  // aplly btn  change color start
  gateAndSetAllFilters() {
    this.gateAllFilters();
    this.makeAllFilterToString();
  }

  gateAllFilters() {
    let filterData: VehicleTransferScreenFilterModel = this.userCommonService.getSavedFilters(AppSettings.FILTER_SCREEN_CODE.VEHICLE_TRANSFER_SCREEN);
    if (filterData) {
      let localData = filterData.filterData;
      this.originalFilterData = localData;
      this.changedFilterData = { ...localData };
      return filterData;
    } else {
      setTimeout(() => {
        this.resetFilter();
      }, 100);
    }
  }

  makeAllFilterToString() {
    if (this.originalFilterData) {
      let keys = Object.keys(this.originalFilterData);
      for (let i = 0; i < keys.length; i++) {
        this.changedFilterData[keys[i]] = this.changedFilterData[keys[i]] ? this.changedFilterData[keys[i]] : '';
        this.originalFilterData[keys[i]] = this.originalFilterData[keys[i]] ? this.originalFilterData[keys[i]] : '';
      }
    }
  }

  changeFilter(key?, val?) {
    if (key === "selectedSortType" && val === "eta") {
      this.showETAFilter = true
    } else if (key === "selectedSortType" && val != "eta") {
      this.showETAFilter = false
      this.nextAvailableTime = 0
    }
    this.changedFilterData[key] = val.toString();
    let changedvalus = [];
    let keys = Object.keys(this.originalFilterData);
    for (let i = 0; i < keys.length; i++) {
      if (this.originalFilterData[keys[i]] !== this.changedFilterData[keys[i]]) {
        changedvalus.push(keys[i]);
      }
    }
    this.filterApplied = false;
    if (changedvalus.length > 0) {
      this.filterApplied = true;
    }
    if (key === 'selectedDispatchAddress') {
      this.getPickupAddress();
    }
  }
  // aplly btn  change color end

  onMergeComplete(result: any) {
    this.refreshGrid();
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  onMergePopupClose() {
    this.refreshGrid();
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  ngOnDestroy() {
    if (this._broadSub) {
      this._broadSub.unsubscribe();
    }
  }

  openUnmergePopup(data) {
    this.confirmationService.confirm({
      message: 'This is a merge booking, confirming the unmerging you can now merge additional booking?',
      accept: () => {
        this.performUnmerge(data);
      }
    });
  }

  performUnmerge(data) {
    const unmergeData = {
      tourIdList: [data.id],
    };
    
    this.bookingService.unmergeBookings(this.eventIdParam, unmergeData).subscribe(
      (result) => {
        this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
        this.refreshGrid();
        this.commonBindingDataService.bookingTabCountChange.next(true);
      },
      (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        this.refreshGrid();
      }
    );
  }

  closeCancellationReasonPopup(): void {
    this.showCancellationReasonPopup = false;
    this.refreshGrid();
  }

  onCancellationConfirm(event: { passengerNote: string; bookingNote: string }): void {
    this.showCancellationReasonPopup = false;
    this.refreshGrid();
  }
}